import { FormFieldEntry } from '../../utilities/requiredFieldsFilled';

export interface FileMetadataDTO {
  fileId: string;
  fileName: string;
  fileDescription: string;
  fileUrl?: string | undefined;
}
export interface DocumentMetadataDTO {
  category: string;
  document: FileMetadataDTO;
}

export interface ConfigurationMetadataDTO {
  category: string;
  configurationFile: FileMetadataDTO;
}

export enum SolutionPhase {
  SOLUTION_PHASE_UNSPECIFIED = 'SOLUTION_PHASE_UNSPECIFIED',
  DRAFT = 'DRAFT',
  TECH_REVIEW = 'TECH_REVIEW',
  READY_TO_PUBLISH = 'READY_TO_PUBLISH',
  MARKETPLACE_PUBLISH_REVIEW = 'MARKETPLACE_PUBLISH_REVIEW',
  INTERNAL_PUBLISH_REVIEW = 'INTERNAL_PUBLISH_REVIEW',
  LIVE = 'LIVE',
  DEPRECIATED = 'DEPRECIATED',
}

export enum SolutionLifecycleEventCommand {
  SUBMIT_FOR_TECH_REVIEW = 'SUBMIT_FOR_TECH_REVIEW',
  DECLINE_TECH_REVIEW = 'DECLINE_TECH_REVIEW',
  WITHDRAW_FROM_TECH_REVIEW = 'WITHDRAW_FROM_TECH_REVIEW',
  APPROVE_TECH_REVIEW = 'APPROVE_TECH_REVIEW',
  SUBMIT_FOR_INTERNAL_PUBLISH_REVIEW = 'SUBMIT_FOR_INTERNAL_PUBLISH_REVIEW',
  SUBMIT_FOR_MARKETPLACE_PUBLISH_REVIEW = 'SUBMIT_FOR_MARKETPLACE_PUBLISH_REVIEW',
  APPROVE_INTERNAL_PUBLISH = 'APPROVE_INTERNAL_PUBLISH',
  APPROVE_MARKETPLACE_PUBLISH = 'APPROVE_MARKETPLACE_PUBLISH',
  DEPRECIATE = 'DEPRECIATE',
}

export enum SolutionDocumentCategory {
  DRAFT = 'DRAFT',
  TECH_REVIEW = 'TECH_REVIEW',
  READY_TO_PUBLISH = 'READY_TO_PUBLISH',
  MARKETPLACE_PUBLISH_REVIEW = 'MARKETPLACE_PUBLISH_REVIEW',
  INTERNAL_PUBLISH_REVIEW = 'INTERNAL_PUBLISH_REVIEW',
  LIVE = 'LIVE',
  DEPRECIATED = 'DEPRECIATED',
}

export type SolutionInputFields = {
  [x: string]: FormFieldEntry;
  displayName: string;
  shortDescription: string;
  categories: string[];
  visibility: {
    isMarketplaceVisible: boolean;
  };
  version: string;
};

export interface SolutionDTO {
  solutionId: string;
  versions: SolutionVersionDTO[];
}

export interface SolutionVersionDTO
  extends SolutionVersionIdentifierDTO,
    SolutionDisplayAttributesDTO,
    SolutionClassificationDTO,
    SolutionCompatibilityDTO,
    SolutionVisibilityDTO,
    SolutionDisplayAttributesDTO,
    SolutionTermsDTO {
  [key: string]: any;
  version: string;
  categories: Array<string>;
  phase: SolutionPhase;
  images: Array<FileMetadataDTO>;
  icon?: FileMetadataDTO;
  documents: Array<DocumentMetadataDTO>;
  configurations: Array<ConfigurationMetadataDTO>;
  applications: Array<SolutionApplicationDTO>;
  solutionInitializationConfiguration?: SolutionInitializationConfigurationDTO;
}

export interface SolutionClassificationDTO {
  categories: Array<string>;
}

export interface SolutionCompatibilityDTO {
  isMarketplaceCompatible: boolean;
  isConsoleCompatible: boolean;
}

export interface SolutionVisibilityDTO {
  visibility: {
    isMarketplaceVisible: boolean;
  };
}

export interface SolutionApplicationDTO {
  appId: string;
  appVersionId: string;
  displayOrder?: number;
}
export interface SolutionTermsDTO {
  isCopyrightFree: boolean;
}
export interface SolutionDisplayAttributesDTO {
  displayName: string;
  longDescription: string;
  shortDescription: string;
}

export interface SolutionVersionIdentifierDTO {
  solutionId: string;
  solutionVersionId: string;
}

export interface ApplicationVersionIdentifierDTO {
  appId: string;
  appVersionId: string;
}
export interface AppInitializationSequenceDTO {
  id: ApplicationVersionIdentifierDTO;
  appUrn: string;
  initilizationSequenceNumber: number;
}

export interface SolutionInitializationConfigurationDTO {
  appInitializationSequence: Array<AppInitializationSequenceDTO>;
}

export interface RegisterSolutionRequestDTO extends SolutionVisibilityDTO {
  displayName: string;
  version: string;
  shortDescription: string;
  categories: string[];
}

export interface RegisterSolutionResponseDTO {
  solutionId: string;
}

export interface SolutionCategory {
  id: string;
  displayName: string;
}

export interface MutableSolutionAttributesDTO
  extends Partial<SolutionDisplayAttributesDTO>,
    Partial<SolutionClassificationDTO>,
    Partial<SolutionTermsDTO>,
    Partial<SolutionVisibilityDTO> {
  displayName?: string;
  shortDescription?: string;
  longDescription?: string;
  categories?: Array<string>;
  isCopyrightFree?: boolean;
}
